import { Box, Typography } from "@mui/material";
import React from "react";

export interface OtlFormHeaderProps {}

export function OtlFormHeader({}: OtlFormHeaderProps) {
  return (
    <Box>
      <Typography variant="h5" textTransform="uppercase" mb={2}>
        Fall 2026 applications for IRC On-the-Land Support
      </Typography>
      <Typography paragraph>
        Applications are now open for fall 2026 on-the-land support, offered to
        IFA beneficiary households who will be travelling on the land within the
        Inuvialuit Settlement Region this fall 2026 season.
      </Typography>
      <Typography paragraph>
        The first deadline for the applications is Tuesday, October 6, 2026 at
        12pm MST. Vouchers will be available for pick-up starting Friday,
        October 9.
      </Typography>
      <Typography paragraph>
        If you need more time to complete your on-the-land application, you can
        submit an application until the program closes on Tuesday, October 13 at
        12pm MST. With this final deadline, vouchers will be available in stores
        starting Friday, October 16.
      </Typography>
      <Typography>How it works:</Typography>
      <ul>
        <Typography component="li">
          One application is accepted per Inuvialuit household, the first
          application form received from each household will be used.
        </Typography>
        <Typography component="li">
          Applicants required to pick up their own vouchers
        </Typography>
        <Typography component="li">
          Beneficiaries can apply using this form. Call 867.777.7000 or email{" "}
          <a href="mailto:info@inuvialuit.com">info@inuvialuit.com</a> with any
          questions about this program or for assistance with an application.
        </Typography>
        <Typography component="li">
          Approved households will receive a voucher for $300 for gas and $400
          for groceries.
        </Typography>
      </ul>
      <Typography paragraph>
        Please be sure to indicate the community where you would like to pick up
        your vouchers and your preferred gas station and grocery store on the
        application. We encourage you to use beneficiary-owned and operated
        companies if possible.
      </Typography>
      <Typography paragraph>
        IRC wishes everyone safe travels and to be prepared for changing weather
        conditions.
      </Typography>
    </Box>
  );
}
